<script setup>

import logo from '@/assets/logo.svg'
import dayjs from 'dayjs'
import { onBeforeMount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import DashboardOverview from '@/views/dashboard/index.vue'
import Sidebar from './components/Sidebar.vue';

const isCollapsed = ref(false);

defineOptions({ name: 'LayoutView' })
// const reportUpdateTime = dayjs(new Date()).format('YYYY年M月D日 HH:mm')
const reportUpdateTime = ref()

const route = useRoute()
const router = useRouter()

const handleSelect = (key, keyPath) => {
  // console.log(key, keyPath)
  // console.log(route.path, '---', route.name)
}

onMounted(() => {
  // const params = new URLSearchParams(window.location.search)
  // const code = params.get('code')
  // if (code && code !== '') {
  //   localStorage.setItem('code', code)
  // }
  console.log("token code:",localStorage.getItem("code"))
})

const showReportUpdateTime = (reportTime) => {
  reportUpdateTime.value = reportTime;
}

// watch(() => route.query.code, (code) => {
//   if (code && code !== '') {
//     localStorage.setItem('code', code)
//   }
// }, { immediate: true })
</script>

<template>
  <div class="layout">
    <div class="header">
      <logo class="logo-icon" />
      <span>HCP360 Operation Report</span>
      <div class="hint">数据更新时间：{{ reportUpdateTime }}</div>
    </div>
    <div class="main">
      <Sidebar v-model:isCollapsed="isCollapsed" />
      <div class="content" :class="{ 'collapsed': isCollapsed }">
        <div class="content__header"></div>
        <div class="content__overview">
          <el-card shadow="hover">
            <DashboardOverview @show-report-update-time = "showReportUpdateTime"/>
          </el-card>
        </div>
        <div class="content__panel">
          <el-card shadow="hover">
            <template #header>
              <el-menu
                :default-active="$route.name"
                class="content__panel-menu"
                mode="horizontal"
                router
                @select="handleSelect">
                <el-menu-item index="AnalysisTrend" :route="{ name: 'AnalysisTrend' }">趋势分析
                </el-menu-item>
                <el-menu-item index="AnalysisArchitecture"
                              :route="{ name: 'AnalysisArchitecture' }">架构分析
                </el-menu-item>
                <el-menu-item index="AnalysisModule" :route="{ name: 'AnalysisModule' }">模块分析
                </el-menu-item>
                <el-menu-item index="AnalysisMicroJourney"
                              :route="{ name: 'AnalysisMicroJourney' }">Micro Journey
                </el-menu-item>
              </el-menu>
            </template>
            <template #default>
              <RouterView />
            </template>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    display: flex;
    align-items: center;
    padding: 0 var(--space-md);
    height: 3.75rem;
    background-color: var(--color-primary-dark);
    color: var(--color-text-on-primary);
    line-height: 3.75rem;
    font-size: 1.25rem;
    text-transform: uppercase;

    .logo-icon {
      width: 2.7rem;
      aspect-ratio: 1 / 1;
      margin-right: var(--space-xs);
    }

    span {
      font-weight: bold;
    }

    .hint {
      margin-left: auto;
      font-size: 1rem;
    }
  }

  .main {
    display: flex;
    flex: 1;
    overflow: hidden;

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 1rem;
      overflow: auto;
      transition: margin-left 0.3s ease;

      &.collapsed {
        margin-left: -240px;
      }

      &__header {
      }

      &__overview {
        flex-shrink: 0;
        margin-bottom: 1rem;
        height: 16rem;

        .el-card {
          height: 100%;
        }

        ::v-deep(.el-card__body) {
          height: 100%;
          padding: 1rem;
        }
      }

      &__panel {
        flex: 1;

        .el-card {
          height: 100%;
        }

        ::v-deep(.el-card__header) {
          padding: 0;
          border-bottom-width: 0;
        }

        &-menu {
          --el-menu-bg-color: var(--color-primary);
          --el-menu-text-color: var(--color-text-on-primary);
          --el-menu-active-color: var(--color-text-on-primary);
          --el-menu-hover-bg-color: transparent;
        }

        ::v-deep(.el-menu--horizontal>.el-menu-item.is-active) {
          font-weight: bold;
          border-bottom-color: var(--az-color-gold-100);
        }

        ::v-deep(.el-menu-item) {
          margin: 0 var(--space-md);
        }

        ::v-deep(.el-card__body) {
          height: calc(100% - 60px);
        }
      }
    }
  }
}

</style>
